/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { UPDATE_EVENT } from "./actionTypes"
import { updateEventSuccess, updateEventError } from "./actions"

//Include Both Helper File with needed methods
import { editEvent } from "../../../helpers/backend_helper"

function* update(action) {
  try {
    const response = yield call(editEvent, action.payload.event)
    if (response.statusCode) throw new Error(response.message)
    yield put(updateEventSuccess(response))
  } catch (error) {
    yield put(updateEventError(error))
  }
}

function* updateEventSaga() {
  yield takeEvery(UPDATE_EVENT, update)
}

export default updateEventSaga
